import Api from "./Api";
import apiPath from "@/constants/api.js";

export default {
  getAccessStat(data) {
    const response = Api().post(apiPath.stat + "access_stat", data, {});
    return response;
  },

  getUriStat(data) {
    const response = Api().post(apiPath.stat + "uri_stat", data, {});
    return response;
  },

  getUserStat() {
    const response = Api().post(apiPath.stat + "user_stat", {});
    return response;
  },

  getBannerStat(data) {
    const response = Api().post(apiPath.stat + "banner_stat", data, {});
    return response;
  },

  getBannerStatDaily(data, id) {
    const response = Api().post(apiPath.stat + "banner_stat_daily/" + id, data, {});
    return response;
  },

  getBannerStatMonthly(data, id) {
    const response = Api().post(apiPath.stat + "banner_stat_monthly/" + id, data, {});
    return response;
  },

  downloadStat(headers, stat, data) {
    const response = Api().post(apiPath.stat + stat, data, headers);
    return response;
  },
};
